import autobind from 'autobind-decorator';
import { computed, extendObservable, toJS } from 'mobx';

@autobind
class TeamGameStatModel {
  constructor(data) {
    extendObservable(this, data);
  }
  @computed
  get chart() {
    const {
      shooting,
      shotsOnTarget,
      foul,
      corner,
      freeKick,
      offside,
      yellowCardCount,
      redCardCount,
      possession,
      save,
      interception1,
      tackle,
      missedShot,
      blockedShot,
      passAttempted,
      passCompleted,
      interception2,
      attack,
      dangerousAttack,
      expectedGoal,
      bigChance,
      hitWoodwork,
      shotInsideBox,
      shotOutsideBox,
      touchOpponentBox,
    } = this;

    let result = {
      shooting: { p: 0, v: '' },
      shotsOnTarget: { p: 0, v: '' },
      foul: { p: 0, v: '' },
      corner: { p: 0, v: '' },
      freeKick: { p: 0, v: '' },
      offside: { p: 0, v: '' },
      yellowCardCount: { p: 0, v: '' },
      redCardCount: { p: 0, v: '' },
      possession: { p: 0, v: '' },
      save: { p: 0, v: '' },
      interception1: { p: 0, v: '' },
      tackle: { p: 0, v: '' },
      missedShot: { p: 0, v: '' },
      blockedShot: { p: 0, v: '' },
      passAttempted: { p: 0, v: '' },
      passCompleted: { p: 0, v: '' },
      interception2: { p: 0, v: '' },
      attack: { p: 0, v: '' },
      dangerousAttack: { p: 0, v: '' },
      expectedGoal: { p: 0, v: '' },
      bigChance: { p: 0, v: '' },
      hitWoodwork: { p: 0, v: '' },
      shotInsideBox: { p: 0, v: '' },
      shotOutsideBox: { p: 0, v: '' },
      touchOpponentBox: { p: 0, v: '' },
    };

    if (!!shooting) {
      const percent = +((shooting / 20) * 100).toFixed(1);

      result.shooting = {
        p: percent > 100 ? 100 : percent,
        v: shooting,
      };
    }

    if (shotsOnTarget) {
      const percent = +((shotsOnTarget / 20) * 100).toFixed(1);

      result.shotsOnTarget = {
        p: percent > 100 ? 100 : percent,
        v: shotsOnTarget,
      };
    }

    if (foul) {
      const percent = +((foul / 50) * 100).toFixed(1);

      result.foul = {
        p: percent > 100 ? 100 : percent,
        v: foul,
      };
    }

    if (corner) {
      const percent = +((corner / 20) * 100).toFixed(1);

      result.corner = {
        p: percent > 100 ? 100 : percent,
        v: corner,
      };
    }

    if (freeKick) {
      const percent = +((freeKick / 50) * 100).toFixed(1);

      result.freeKick = {
        p: percent > 100 ? 100 : percent,
        v: freeKick,
      };
    }

    if (offside) {
      const percent = +((offside / 10) * 100).toFixed(1);

      result.offside = {
        p: percent > 100 ? 100 : percent,
        v: offside,
      };
    }

    if (yellowCardCount) {
      const percent = +((yellowCardCount / 10) * 100).toFixed(1);

      result.yellowCardCount = {
        p: percent > 100 ? 100 : percent,
        v: yellowCardCount,
      };
    }

    if (redCardCount) {
      const percent = +((redCardCount / 10) * 100).toFixed(1);

      result.redCardCount = {
        p: percent > 100 ? 100 : percent,
        v: redCardCount,
      };
    }

    if (possession) {
      const percent = +((possession / 50) * 100).toFixed(1);

      result.possession = {
        p: percent > 100 ? 100 : percent,
        v: possession,
      };
    }

    if (save) {
      const percent = +((save / 10) * 100).toFixed(1);

      result.save = {
        p: percent > 100 ? 100 : percent,
        v: save,
      };
    }

    if (interception1) {
      const percent = +((interception1 / 50) * 100).toFixed(1);

      result.interception1 = {
        p: percent > 100 ? 100 : percent,
        v: interception1,
      };
    }

    if (tackle) {
      const percent = +((tackle / 20) * 100).toFixed(1);

      result.tackle = {
        p: percent > 100 ? 100 : percent,
        v: tackle,
      };
    }

    if (missedShot) {
      const percent = +((missedShot / 10) * 100).toFixed(1);

      result.missedShot = {
        p: percent > 100 ? 100 : percent,
        v: missedShot,
      };
    }

    if (blockedShot) {
      const percent = +((blockedShot / 20) * 100).toFixed(1);

      result.blockedShot = {
        p: percent > 100 ? 100 : percent,
        v: blockedShot,
      };
    }

    if (passAttempted) {
      const percent = +((passAttempted / 500) * 100).toFixed(1);

      result.passAttempted = {
        p: percent > 100 ? 100 : percent,
        v: passAttempted,
      };
    }

    if (passCompleted) {
      const percent = +((passCompleted / 500) * 100).toFixed(1);

      result.passCompleted = {
        p: percent > 100 ? 100 : percent,
        v: passCompleted,
      };
    }

    if (interception2) {
      const percent = +((interception2 / 50) * 100).toFixed(1);

      result.interception2 = {
        p: percent > 100 ? 100 : percent,
        v: interception2,
      };
    }

    if (attack) {
      const percent = +((attack / 200) * 100).toFixed(1);

      result.attack = {
        p: percent > 100 ? 100 : percent,
        v: attack,
      };
    }

    if (dangerousAttack) {
      const percent = +((dangerousAttack / 100) * 100).toFixed(1);

      result.dangerousAttack = {
        p: percent > 100 ? 100 : percent,
        v: dangerousAttack,
      };
    }

    if (expectedGoal) {
      const percent = expectedGoal * 20;

      result.expectedGoal = {
        p: percent > 100 ? 100 : percent,
        v: expectedGoal,
      };
    }

    if (bigChance) {
      const percent = +((bigChance / 10) * 100).toFixed(1);

      result.bigChance = {
        p: percent > 100 ? 100 : percent,
        v: bigChance,
      };
    }

    if (hitWoodwork) {
      const percent = +((hitWoodwork / 50) * 100).toFixed(1);

      result.hitWoodwork = {
        p: percent > 100 ? 100 : percent,
        v: hitWoodwork,
      };
    }

    if (shotInsideBox) {
      const percent = +((shotInsideBox / 20) * 100).toFixed(1);

      result.shotInsideBox = {
        p: percent > 100 ? 100 : percent,
        v: shotInsideBox,
      };
    }

    if (shotOutsideBox) {
      const percent = +((shotOutsideBox / 20) * 100).toFixed(1);

      result.shotOutsideBox = {
        p: percent > 100 ? 100 : percent,
        v: shotOutsideBox,
      };
    }

    if (touchOpponentBox) {
      const percent = +((touchOpponentBox / 50) * 100).toFixed(1);

      result.touchOpponentBox = {
        p: percent > 100 ? 100 : percent,
        v: touchOpponentBox,
      };
    }

    return result;
  }
}

export default TeamGameStatModel;
